import React from 'react';
import { UserOutlined, KeyOutlined, MailOutlined, PhoneOutlined } from '@ant-design/icons';
import { Form, Input, Button, Typography } from 'antd';
import { useAppDispatch } from 'hooks/useStore';
import { useHistory, Link } from 'react-router-dom';
import IconSVG from 'assets/images/5.svg';
import { registration } from 'features/User/UserSlice';
import * as S from './SignUp.styled';
import Meta from 'components/Meta';
import { unwrapResult } from '@reduxjs/toolkit';

const { Title, Text } = Typography;

const SignUp: React.FC = () => {
	const dispatch = useAppDispatch();
	const { push } = useHistory();

	const onHandleSignUp = ({
		email,
		password,
		name,
		phone,
	}: {
		email: string;
		password: string;
		name: string;
		phone: string;
	}) =>
		dispatch(registration({ email, password, phone, name }))
			.then(unwrapResult)
			.then(() => push('/'))
			.catch(console.error);

	return (
		<>
			<Meta pageName="signUp" />
			<S.SignUp>
				<S.Form>
					<Form
						name="basic"
						labelCol={{ span: 0 }}
						wrapperCol={{ span: 24 }}
						style={{ borderRadius: '3px' }}
						initialValues={{
							email: '',
							password: '',
							name: '',
							phone: '',
						}}
						onFinish={onHandleSignUp}
						autoComplete="off"
						className="form">
						<S.Head>
							<img
								src={IconSVG}
								alt="SMART PROPERTY UAE"
								style={{ maxHeight: 144, marginBottom: 20, borderRadius: 32 }}
							/>
							<Title level={5} style={{ marginBottom: '4px' }}>
								SMART PROPERTY UAE
							</Title>
							<Text type="secondary">
								Sign up to create, discover, and connect with the common platform of property UAE
							</Text>
						</S.Head>
						<Form.Item name="name" style={{ marginBottom: 14 }}>
							<Input
								placeholder="Name"
								prefix={<UserOutlined style={{ marginRight: 4, color: '#B7B7B7' }} />}
								autoComplete="off"
							/>
						</Form.Item>
						<Form.Item
							name="phone"
							style={{ marginBottom: 14 }}
							rules={[{ required: true, message: 'Please input your phone!' }]}>
							<Input
								placeholder="Phone"
								prefix={<PhoneOutlined style={{ marginRight: 4, color: '#B7B7B7' }} />}
								autoComplete="off"
							/>
						</Form.Item>
						<Form.Item
							name="email"
							style={{ marginBottom: 14 }}
							rules={[{ required: true, message: 'Please input your email!' }]}>
							<Input
								placeholder="Email"
								prefix={<MailOutlined style={{ marginRight: 4, color: '#B7B7B7' }} />}
								autoComplete="off"
							/>
						</Form.Item>
						<Form.Item
							name="password"
							rules={[{ required: true, message: 'Please input your password' }]}
							style={{ marginBottom: 14 }}>
							<Input.Password
								placeholder="Password"
								prefix={<KeyOutlined style={{ marginRight: 4, color: '#B7B7B7' }} />}
								autoComplete="off"
							/>
						</Form.Item>
						<Form.Item wrapperCol={{ offset: 0, span: 24 }} style={{ marginBottom: 14 }}>
							<Button type="primary" htmlType="submit" style={{ width: '100%' }}>
								Create account
							</Button>
						</Form.Item>
						<Form.Item wrapperCol={{ offset: 0, span: 24 }} style={{ marginBottom: 0 }}>
							<Link to="/login">
								<Button style={{ width: '100%' }} htmlType="button">
									Log in
								</Button>
							</Link>
						</Form.Item>
						<Form.Item wrapperCol={{ offset: 0, span: 24 }} style={{ marginBottom: 0 }}>
							<S.Policy>
								By signing up I agree to the{' '}
								<a
									href="http://realty-uae.maksimzaycev.ru/privacy"
									target="_blank"
									rel="noreferrer">
									Privacy Policy
								</a>
							</S.Policy>
						</Form.Item>
					</Form>
				</S.Form>
			</S.SignUp>
		</>
	);
};

export default SignUp;
